var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M41.45,1l0-.49L41,.73c-.1,0-9.25,4.46-13.78-.48L27,0l-.23.24C22,5.19,13.07.78,13,.73L12.55.51l0,.5c0,.7-.79,17.26,7,25,1.86,1.84,7,5.68,7.24,5.84L27,32l.18-.13a87.86,87.86,0,0,0,7.34-5.76C42.25,18.41,41.49,1.71,41.45,1ZM27,5a4.67,4.67,0,0,1,0,9.34,4.62,4.62,0,0,1-4.56-4.67A4.61,4.61,0,0,1,27,5Zm7,15.42a.33.33,0,0,1-.33.33H20.33a.32.32,0,0,1-.32-.33V18.26a2.35,2.35,0,0,1,1.27-2.37l3-1.43a.31.31,0,0,1,.28,0,5.23,5.23,0,0,0,2.38.61h0a5.19,5.19,0,0,0,2.38-.61.33.33,0,0,1,.29,0l3,1.43A2.36,2.36,0,0,1,34,18.26Z",
    transform: "translate(-12.49)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.80d342fe.svg";
export { ForwardRef as ReactComponent };